import { useModalStore } from "@/stores/modalStore";

let zIndex = 1000;

export default function useModals() {
  const modalStore = useModalStore();

  const activateLastModal = (): void => {
    if (modalStore.stack.length) {
      modalStore.stack[modalStore.stack.length - 1].active = true;
    }
  };
  const deActivateModals = (): void => {
    modalStore.stack.forEach((ms) => (ms.active = false));
  };

  const add = (modalName: string, closeCallback: () => void): void => {
    const modalState = modalStore.stack.find((ms) => ms.modalName === modalName);
    zIndex = zIndex + 10;
    if (!modalState) {
      const modalState = {
        modalName,
        closeCallback,
        zIndex,
        active: true,
      };
      deActivateModals();
      modalStore.stack.push(modalState);
    }
  };

  const remove = (modalName: string): void => {
    const targetModal = modalStore.stack.find((modalState) => modalState.modalName === modalName);
    if (!targetModal) return;
    zIndex = zIndex - 10;
    targetModal?.closeCallback();
    modalStore.stack = [...modalStore.stack.filter((ms) => ms.modalName !== modalName)];
    activateLastModal();
  };

  return {
    add,
    remove,
  };
}
